import type {ReactElement} from 'react';
import React from 'react';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import type {RGBA} from '@Utils/color.util';
import {getRGBAArrayFromColorStorage} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import type {ColorStorage} from '@Components/color-picker-v2';

interface BaseTintColorPanelProps {
  tintColor: RGBA;
  onUpdateTintColor(tintColor: RGBA, undoable?: boolean): void;
}

export function BaseTintColorPanel({...props}: BaseTintColorPanelProps): ReactElement<any> {
  const updateTintColor = (tintColor: RGBA, undoable = true): void => {
    props.onUpdateTintColor(tintColor, undoable);
  };

  const onChangeTintColor = (updatedColor: ColorStorage[]): void => {
    updateTintColor(getRGBAArrayFromColorStorage(updatedColor)[0], false);
  };

  const onChangeColorEnded = (updatedColor: ColorStorage[]): void => {
    updateTintColor(getRGBAArrayFromColorStorage(updatedColor)[0]);
  };
  return (
    <PosterEditingBaseColorPanel
      id="item-tint-color-panel"
      color={getColorObjectArrayFromFillColor([props.tintColor])}
      onChangeColor={onChangeTintColor}
      onChangeEnded={onChangeColorEnded}
      isGradientEnabled={false}
    />
  );
}
